import React, { useState } from 'react'
import assets from '../assets'
import './index.css'

const Header = () => {

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className='header'>
        <div className="container-lg flex flexRow justifySpace">
            <img src={assets.logo} alt="Logo" />
            <div className={isOpen ? "menuOpen menuButton" : "menuButton"} onClick={() => setIsOpen(!isOpen)}>
              <span></span>
              <span></span>
            </div>
            <div className={(isOpen ? 'navOpen ' : '') + "menu flex flexRow gap"}>
                <a href="#explore" onClick={() => setIsOpen(!isOpen)}>Explore</a>
                <a href="#build" onClick={() => setIsOpen(!isOpen)}>Build</a>
                <a href="#econbrain" onClick={() => setIsOpen(!isOpen)}>Econ Brain</a>
            </div>
        </div>
    </div>
  )
}

export default Header